import React, { useContext } from "react";

const WidthContext = React.createContext({});

export const WidthProvider = WidthContext.Provider;

export const useWidth = () => useContext(WidthContext);